export default (params) => {
  const { fieldData } = params;

  const {
    document: { nodes: documentNodes },
  } = fieldData;

  const [objectiveNode] = documentNodes;
  const { nodes: inlineNodes } = objectiveNode;

  /**
   * Remove bullets
   */

  let textNode = '';
  inlineNodes.forEach((inlineNode) => {
    if (inlineNode.type !== 'paragraph') textNode = inlineNode;
  });
  if (!textNode) return { letterBody: fieldData };

  const updatedLetterBody = {
    object: 'value',
    document: {
      object: 'document',
      data: {
        version: {
          number: 2,
          updated: true,
        },
      },
      nodes: [
        {
          object: 'block',
          type: 'letter_body',
          nodes: [
            {
              object: 'block',
              type: 'paragraph',
              nodes: [
                {
                  ...textNode,
                },
              ],
            },
          ],
        },
      ],
    },
  };
  return { letterBody: updatedLetterBody };
};
